export default "__VITE_ASSET__BbAbNMYv__"